module.exports = __webpack_public_path__ + "static/media/place-of-worship.9db3e27c.svg";